import { render } from "./propertiesSignature.vue?vue&type=template&id=5ef0bd8d"
import script from "./propertiesSignature.vue?vue&type=script&lang=js"
export * from "./propertiesSignature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__